import {API_ACTIVITY_TYPE, API_ACTIVITY_VERB} from '@webex/react-component-utils';

/**
 * Parses the giphy file object and set the url correctly
 * @param {Object} fileObject
 * @returns {Object}
 */
function convertGiphyFileObject(fileObject) {
  const normalizedFileObject = Object.assign({}, fileObject);

  normalizedFileObject.image.displayName = fileObject.displayName;
  normalizedFileObject.url = fileObject.scr.loc;
  // Set scr to null so we don't try to decrypt content in the sdk
  normalizedFileObject.scr = null;

  return normalizedFileObject;
}


/**
 * Normalizes an activity received from the conversation service
 * @param {Object} a
 * @returns {Object}
 */
export function normalizeActivity(a) {
  const activity = Object.assign({}, a);

  if (activity.verb === 'share' && activity.object && activity.object.files && Array.isArray(activity.object.files.items)) {
    // Apply giphy fix to file url
    activity.object.files.items = activity.object.files.items.map((fileObject) => {
      if (fileObject.url.includes('giphy')) {
        return convertGiphyFileObject(fileObject);
      }

      return fileObject;
    });
  }

  return activity;
}

/**
 * Normalizes an array of activities received from the conversation service
 * @param {Array} activities
 * @returns {Array}
 */
export function normalizeActivities(activities) {
  return activities.map(normalizeActivity);
}

/**
 * Filters a raw list of activities for those we are interested in
 *
 * @param {array} activities
 * @returns {array}
 */
export function filterActivities(activities) {
  return activities.filter((a) => {
    const isUpdate = a.verb === API_ACTIVITY_VERB.UPDATE;
    const isContent = a.object && a.object.objectType === 'content';
    const isReply = a.type === API_ACTIVITY_TYPE.REPLY;
    let shouldInclude = true;

    // Content updates show up out of order and should not be displayed
    if (isUpdate && isContent) {
      shouldInclude = false;
    }

    // Threaded replies are not currently supported
    if (isReply) {
      shouldInclude = false;
    }

    return shouldInclude;
  });
}
